import { render, staticRenderFns } from "./PaginaTabelleGettoniGaraAddettiService.vue?vue&type=template&id=d58e010a&"
import script from "./PaginaTabelleGettoniGaraAddettiService.vue?vue&type=script&lang=js&"
export * from "./PaginaTabelleGettoniGaraAddettiService.vue?vue&type=script&lang=js&"
import style0 from "./PaginaTabelleGettoniGaraAddettiService.vue?vue&type=style&index=0&id=d58e010a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports